import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/leave-management-system/leave-approval/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "leave-approval" entry is kept); the seo block below is a fallback.

export const leaveApproval: ContentPage = {
  slug: "leave-management-system/leave-approval",
  template: "hrmsFeature",
  seo: {
    title: "Leave Approval System - Automate Employee Leave Requests",
    description: "Simplify the leave approval process with automated workflows and real-time notifications. Manage employee leave approvals easily with our system.",
    keywords: [
      "leave approval process",
      "automated leave approval",
      "leave request approval",
      "employee leave system",
      "multi-level approval workflow",
      "HR leave approval",
    ],
    ogImage: "/assets/data/seoimages/leave-approval.webp",
  },
  leaf: {
    hero: {
      caption: "Leave Approval",
      title: "Efficient Leave Approval Process for Managers",
      description: "Automate and simplify the leave approval process, ensuring fast and accurate decision-making for managers with real-time updates and notifications.",
      h1: "caption",
    },
    split: {
      title: "Efficient Leave Approval System for Seamless Operations",
      bullets: [
        { title: "Automated Approval Workflow", description: "Automatically route leave requests to the right managers for efficient and accurate processing." },
        { title: "Customizable Approval Levels", description: "Set up single or multi-level approvals tailored to leave type, department, or employee seniority." },
        { title: "Real-Time Notifications", description: "Get immediate notifications for leave requests' status, keeping managers and employees informed." },
        { title: "Mobile-Friendly Approvals", description: "Review and approve leave requests from any device, whether in the office or on the go." },
      ],
      image: "/assets/images/img/product/hrms/leavems/leave_approval.webp",
      imageAlt: "leave_approval",
    },
    cardsHeading: {
      title: "Key Features of Leave Management System",
      description: "Optimize leave management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Leave Balance",
        href: "/hrms-software/leave-management-system/leave-balance",
        description: "Keep track of employee leave balances in real-time, ensuring transparency and accurate record-keeping.",
        image: "/assets/images/img/product/hrms/leavems/leave_balance_features.webp",
        imageAlt: "leave_balance",
      },
      {
        title: "Leave Request",
        href: "/hrms-software/leave-management-system/leave-requests/",
        description: "Integrate seamlessly with payroll, HR, and ERP systems to provide a unified leave request management experience that enhances efficiency.",
        image: "/assets/images/img/product/hrms/leavems/leave_request_integrAtion_solutions.webp",
        imageAlt: "leave_request_process",
      },
      {
        title: "Leave History",
        href: "/hrms-software/leave-management-system/leave-history",
        description: "Access detailed records of all past leaves, ensuring transparency and easy reference for both employees and HR managers.",
        image: "/assets/images/img/product/hrms/leavems/leave_history.webp",
        imageAlt: "leave_history",
      },
      {
        title: "Leave Types Management",
        href: "/hrms-software/leave-management-system/leave-types",
        description: "Manage various leave types, from sick leave to vacations, with customizable options that cater to your organization’s unique needs.",
        image: "/assets/images/img/product/hrms/leavems/leave_types.webp",
        imageAlt: "leave_types",
      },
    ],
    testimonials: {
      title: "What Our Customers Say",
      description: "Our clients consistently praise the design and functionality of our templates.",
    },
    bookDemoTitle: "Enhance Your Leave Approval Workflow",
    relatedBlogsKeyword: "leave-approval-process-sme,leave-management-software-sme",
    metaKey: "leave-approval",
  },
  sections: [],
};
